import QueryString from "qs";
import { useLocation } from "react-router";

export default function useInitialDataFromMessage() {
  const location = useLocation();
  const data = QueryString.parse(location.search);

  return data;
}
